module.exports = __webpack_public_path__ + "static/media/firearm.51d01e48.svg";